import { useDispatch, useSelector } from 'react-redux';

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

// routing
import Routes from 'routes';
// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import themeDark from 'ThemeDark';
import themeLight from 'ThemeLight';
import { useEffect, useState } from 'react';

import './App.css';
// ==============================|| APP ||============================== //

const App = () => {
    const dispatch = useDispatch();
    const customization = useSelector((state) => state.customization);
    const themeSelect = useSelector((state) => state.theme);
    const [themeChoice, setThemeChoice] = useState(
        JSON.parse(localStorage.getItem('themeDark'))
    );

    useEffect(() => {
        dispatch({
            type: 'theme',
        });
        setThemeChoice(themeSelect);
    }, [dispatch, themeSelect]);

    const theme = () => {
        if (JSON.parse(localStorage.getItem('themeDark')) === null) {
            localStorage.setItem('themeDark', JSON.stringify(true));
        }
    };

    theme();

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider
                theme={themes(
                    customization,
                    themeChoice ? themeDark : themeLight
                )}>
                <CssBaseline />
                <NavigationScroll>
                    <Routes />
                </NavigationScroll>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
